import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useGenerateId, createInputHandler } from '@lendi-jam/atoms';
import Grid, { Grid as Grid$1, Unit } from '@lendi-ui/grid';
import Error$1 from '@lendi-ui/icon/Error';
import { Input } from '@lendi-ui/text-input';
import { Heading, Body, link } from '@lendi-ui/typography';
import { useFormContext, useForm, FormProvider } from 'react-hook-form';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import { Button } from '@lendi-ui/button';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { gte, between } from '@lendi-ui/breakpoint';
import { fg, bg, color } from '@lendi-ui/color';
import getColour, { getColour as getColour$1 } from '@lendi-ui/commons/colours';
import Container from '@lendi-ui/container';
import { RadioGroup } from '@lendi-ui/radio';
import { my, p, mb, mx, px, pr, py, mr, mt } from '@lendi-ui/spacing';
import styled, { css } from 'styled-components';
import numeral from 'numeral';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import * as yup from 'yup';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';

var DebtTypes = /*#__PURE__*/function (DebtTypes) {
  DebtTypes["creditCard"] = "credit card";
  DebtTypes["carLoan"] = "car loan";
  DebtTypes["personalLoan"] = "personal loan";
  DebtTypes["other"] = "other";
  return DebtTypes;
}({});

var HOMELOAN_DEFAULT_VALUES = {
  homeLoanOutstandingAmount: 0,
  homeLoanInterestRate: 0,
  homeLoanMonthlyRepayment: 0,
  homeLoanRemainingTerm: 0
};
var DEBTS_DEFAULT_VALUES = {
  debtType: DebtTypes['creditCard'],
  debtAmount: 0,
  debtInterestRate: 0,
  debtCurrentRepayment: 0,
  debtTerm: 0
};
var REFI_DEFAULT_VALUES = {
  currentTotalDebt: 0,
  newInterestRate: 0,
  newLoanTerm: 0
};
var HOMELOAN_MAXIMUM_VALUES = {
  homeLoanOutstandingAmount: 80000000,
  homeLoanInterestRate: 20,
  homeLoanMonthlyRepayment: 1000000,
  homeLoanRemainingTerm: 30
};
var DEBTS_MAXIMUM_VALUES = {
  debtAmount: 80000000,
  debtCurrentRepayment: 1000000,
  debtInterestRate: 20,
  debtTerm: 30
};
var REFI_MAXIMUM_VALUES = {
  currentTotalDebt: 80000000,
  newInterestRate: 20,
  newLoanTerm: 30
};

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15$1;
var Wrapper$1 = styled(Container)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  ", "\n"])), my('md'));
var Calculator = styled.form(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  background-color: #f8f8f8;\n  border-radius: 5px;\n  ", "\n"])), p({
  lg: 'lg',
  xs: 'md'
}));
var Title = styled(Heading)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  ", "\n"])), mb('sm'));
var StyledHeading$1 = styled(Heading)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  display: block;\n"])));
var StyledUnit = styled(Grid.Unit)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", "\n  row-gap: 6px;\n\n  &:last-child {\n    ", "\n  }\n\n  & > div {\n    width: 100%;\n  }\n"])), mb('md'), mb('nil'));
var StyledButton = styled(Button)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  width: 100%;\n\n  ", "\n  ", "\n"])), gte('lg')(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n    max-width: 36%;\n  "]))), mx('auto'));
var InputAfter = styled(Body)(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  font-weight: 100;\n  ", "\n  ", "\n"])), fg('shade.500'), px('xxs'));
var InputBefore = styled(InputAfter)(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n  ", "\n"])), pr('xxxs'));
var Summary = styled(Body)(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n  ", "\n"])), my('xxs'));
styled.div(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n  width: 100%;\n  ", "\n  height: 1px;\n  flex-basis: 100%;\n"])), bg('shade.50'));
styled(Body)(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 1.15;\n  & a {\n    ", "\n    color: ", ";\n    text-decoration: none;\n    display: inline-block;\n  }\n"])), link({
  size: 'sm'
}), color('primary.500'));
var ResultsWrapper = styled.div(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral(["\n  ", "\n  border: 1px solid #e3e3e3;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  box-sizing: border-box;\n"])), p({
  lg: 'lg',
  xs: 'md'
}));
var StyledRadioGroup = styled(RadioGroup)(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral(["\n  ", "\n  label {\n    border-radius: 0;\n  }\n"])), px('xs'));
var StyledDebtTable = styled.div(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  ", "\n\n  > span {\n    display: block;\n    text-align: center;\n    background: white;\n    width: 20%;\n    border: 1px solid ", ";\n    ", "\n    ", "\n\n    &:first-of-type {\n      color: white;\n      font-weight: bold;\n      background-color: ", ";\n    }\n\n    &:last-of-type {\n      ", "\n    }\n  }\n\n  button:first-of-type {\n    ", "\n  }\n"])), mb('sm'), color('shade.200'), px('sm'), py('xxs'), getColour('text', 'contrast'), mr('md'), mr('xs'));

function sumBy(arr, keyName) {
  if (!arr || arr.length === 0 || !keyName) return 0;
  return arr.reduce(function (accumulator, currentValue) {
    return numeral(accumulator).value() + numeral(currentValue[keyName]).value();
  }, 0);
}

// remaining loan term calculations for existing HOME LOAN.
var calculateHomeLoanRemainingTerm = function calculateHomeLoanRemainingTerm(_ref) {
  var homeLoanOutstandingAmount = _ref.homeLoanOutstandingAmount,
    homeLoanInterestRate = _ref.homeLoanInterestRate,
    homeLoanMonthlyRepayment = _ref.homeLoanMonthlyRepayment;
  var i = (numeral(homeLoanInterestRate).value() || 0) / 100 / 12;
  var loanAmount = numeral(homeLoanOutstandingAmount).value() || 0;
  var monthlyRepayment = numeral(homeLoanMonthlyRepayment).value() || 0;
  var loanTerm = 0;
  loanTerm = -Math.log(1 - i * loanAmount / monthlyRepayment) / Math.log(1 + i) / 12;
  return isNaN(loanTerm) ? NaN : loanTerm === Infinity || loanTerm <= 0 ? 0 : loanTerm;
};

// remaining loan term calculations for existing DEBT.
var calculateCurrentDebtLoanTerm = function calculateCurrentDebtLoanTerm(_ref2) {
  var otherDebt = _ref2.otherDebt;
  var i = (numeral(otherDebt === null || otherDebt === void 0 ? void 0 : otherDebt.debtInterestRate).value() || 0) / 100 / 12;
  var loanAmount = numeral(otherDebt === null || otherDebt === void 0 ? void 0 : otherDebt.debtAmount).value() || 0;
  var monthlyRepayment = numeral(otherDebt === null || otherDebt === void 0 ? void 0 : otherDebt.debtCurrentRepayment).value() || 0;
  var loanTerm = 0;
  loanTerm = -Math.log(1 - i * loanAmount / monthlyRepayment) / Math.log(1 + i) / 12;
  return isNaN(loanTerm) ? NaN : loanTerm === Infinity || loanTerm <= 0 ? 0 : loanTerm;
};

// total loan amounts mapped over all debts and added together with current home loan amount.
var sumOfDebtAmounts = function sumOfDebtAmounts(_ref3) {
  var debts = _ref3.debts,
    homeLoanOutstandingAmount = _ref3.homeLoanOutstandingAmount;
  return sumBy(debts, 'debtAmount') + (numeral(homeLoanOutstandingAmount).value() || 0);
};

// total monthly repayments mapped over all debts and added together with current hom eloan repayment.
var sumOfMonthlyRepayments = function sumOfMonthlyRepayments(_ref4, homeLoanRemainingTerm) {
  var debts = _ref4.debts,
    homeLoanMonthlyRepayment = _ref4.homeLoanMonthlyRepayment;
  var _homeLoanMonthlyRepayment = isNaN(homeLoanRemainingTerm) || homeLoanRemainingTerm > 30 ? 0 : numeral(homeLoanMonthlyRepayment).value() || 0;
  return sumBy(debts, 'debtCurrentRepayment') + _homeLoanMonthlyRepayment;
};

// new repayment amount. i is monthly interest rate. n is loan term in months. a is just an extraction of that part of the formula to make it easier to read.
var calculateNewMonthlyRepayment = function calculateNewMonthlyRepayment(_ref5, sumOfDebtAmounts) {
  var newLoanTerm = _ref5.newLoanTerm,
    newInterestRate = _ref5.newInterestRate;
  if (sumOfDebtAmounts <= 0 || newLoanTerm <= 0 || newInterestRate <= 0) {
    return 0;
  } else {
    var i = (numeral(newInterestRate).value() || 0) / 1200;
    var n = (numeral(newLoanTerm).value() || 0) * 12;
    var a = Math.pow(1 + i, n);
    var newMonthlyRepayment = sumOfDebtAmounts * (i * a) / (a - 1);
    return isNaN(newMonthlyRepayment) || newMonthlyRepayment === Infinity || newMonthlyRepayment <= 0 ? 0 : newMonthlyRepayment;
  }
};

// difference between new and existing repayments.
var calculateExtraCashflow = function calculateExtraCashflow(totalExistingRepayment, newRepayment) {
  var extraCashFlow = totalExistingRepayment - newRepayment;
  return isNaN(extraCashFlow) || extraCashFlow === Infinity || extraCashFlow <= 0 ? 0 : extraCashFlow;
};

// total interest payable mapped over all debts and added together. debtTerm in in months, hence multiplied by 12.
var calculateExistingInterestPayable = function calculateExistingInterestPayable(_ref7, loanTerm) {
  var homeLoanMonthlyRepayment = _ref7.homeLoanMonthlyRepayment,
    homeLoanOutstandingAmount = _ref7.homeLoanOutstandingAmount,
    debts = _ref7.debts;
  var existingInterestPayable = 0;
  var debtInterestPayable = 0;
  var homeLoanInterestPayable = 0;
  homeLoanInterestPayable += (numeral(homeLoanMonthlyRepayment).value() || 0) * (loanTerm * 12) - (numeral(homeLoanOutstandingAmount).value() || 0);
  if (debts) {
    debts.forEach(function (dt) {
      debtInterestPayable += (numeral(dt.debtCurrentRepayment).value() || 0) * ((numeral(dt.debtTerm).value() || 0) * 12) - (numeral(dt.debtAmount).value() || 0);
    });
    existingInterestPayable = debtInterestPayable + homeLoanInterestPayable;
  }
  return isNaN(existingInterestPayable) || existingInterestPayable === Infinity || existingInterestPayable <= 0 ? 0 : existingInterestPayable;
};

// new interest payable.
var calculateNewInterestPayable = function calculateNewInterestPayable(_ref8, newMonthlyRepayment, newLoanAmount) {
  var newLoanTerm = _ref8.newLoanTerm;
  var newInterestPayable = 0;
  if (newMonthlyRepayment <= 0 || newLoanAmount <= 0 || newLoanTerm <= 0) {
    return 0;
  }
  newInterestPayable = newMonthlyRepayment * ((numeral(newLoanTerm).value() || 0) * 12) - newLoanAmount;
  return isNaN(newInterestPayable) || newInterestPayable === Infinity || newInterestPayable <= 0 ? 0 : newInterestPayable;
};

// difference bewteen new and existing interest payable.
var calculateAmountSavedOnInterest = function calculateAmountSavedOnInterest(existingInterestPayable, newInterestPayable) {
  var amountSavedOnInterest = existingInterestPayable - newInterestPayable;
  return isNaN(amountSavedOnInterest) || amountSavedOnInterest === Infinity || amountSavedOnInterest <= 0 ? 0 : amountSavedOnInterest;
};

var OtherDebtsForm = function OtherDebtsForm() {
  var _touched$otherDebt, _touched$otherDebt2, _touched$otherDebt3, _errors$otherDebt, _errors$otherDebt2, _errors$otherDebt3, _errors$otherDebt4, _errors$otherDebt5, _errors$otherDebt6;
  var _useFormContext = useFormContext(),
    getValues = _useFormContext.getValues,
    setValue = _useFormContext.setValue,
    errors = _useFormContext.errors,
    register = _useFormContext.register,
    watch = _useFormContext.watch,
    trigger = _useFormContext.trigger,
    _useFormContext$formS = _useFormContext.formState,
    isDirty = _useFormContext$formS.isDirty,
    touched = _useFormContext$formS.touched;
  // Form states
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    shouldShowForm = _useState2[0],
    setShouldShowForm = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    index = _useState4[0],
    setIndex = _useState4[1];
  var _useState5 = useState(DEBTS_DEFAULT_VALUES.debtType),
    _useState6 = _slicedToArray(_useState5, 2),
    debtType = _useState6[0],
    setDebtType = _useState6[1];
  var generateId = useGenerateId();
  var debtAmountHandler = createInputHandler(DEBTS_MAXIMUM_VALUES.debtAmount, function () {
    return trigger('debtAmount');
  });
  var debtCurrentRepaymentHandler = createInputHandler(DEBTS_MAXIMUM_VALUES.debtCurrentRepayment, function () {
    return trigger('debtCurrentRepayment');
  }, '0');
  var debtInterestRateHandler = createInputHandler(DEBTS_MAXIMUM_VALUES.debtInterestRate, function () {
    return trigger('debtInterestRate');
  }, '0.00');
  var debtTermHandler = createInputHandler(DEBTS_MAXIMUM_VALUES.debtTerm, function () {
    return trigger('debtTerm');
  });
  var resetDebtForm = function resetDebtForm() {
    setValue('otherDebt.debtAmount', 0);
    setValue('otherDebt.debtCurrentRepayment', 0);
    setValue('otherDebt.debtInterestRate', 0);
    setValue('otherDebt.debtTerm', 0);
  };
  var setDebt = function setDebt(data) {
    setValue('otherDebt', _objectSpread({}, data));
  };
  function showForm() {
    setShouldShowForm(true);
  }
  function hideForm() {
    setShouldShowForm(false);
  }
  var saveDebt = function saveDebt(debtType, data) {
    setValue("debts[".concat(index, "].debtAmount"), data.debtAmount);
    setValue("debts[".concat(index, "].debtCurrentRepayment"), data.debtCurrentRepayment);
    setValue("debts[".concat(index, "].debtInterestRate"), data.debtInterestRate);
    setValue("debts[".concat(index, "].debtTerm"), data.debtTerm);
    setValue("debts[".concat(index, "].debtType"), debtType); // separate state for debt type
    setIndex(getValues().debts.length);
    hideForm();
  };
  function onEdit(_x) {
    return _onEdit.apply(this, arguments);
  }
  function _onEdit() {
    _onEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_index) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIndex(_index);
            setDebt(getValues("debts[".concat(_index, "]")));
            setDebtType(getValues("debts[".concat(_index, "].debtType")));
            showForm();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onEdit.apply(this, arguments);
  }
  var onDelete = function onDelete(itemIndex) {
    var _debts = getValues("debts");
    var newDebts = _toConsumableArray(_debts);
    newDebts.splice(itemIndex, 1);
    setValue("debts", newDebts);
  };
  var onAdd = function onAdd() {
    setIndex(getValues().debts !== undefined ? getValues().debts.length : 0);
    resetDebtForm();
    showForm();
  };
  var onCancel = function onCancel() {
    hideForm();
  };
  var formDebts = watch('debts') || [];
  var values = watch();
  var debtRemainingTerm = calculateCurrentDebtLoanTerm(values);
  var showDebtRemainingTermError = ((_touched$otherDebt = touched.otherDebt) === null || _touched$otherDebt === void 0 ? void 0 : _touched$otherDebt.debtAmount) && ((_touched$otherDebt2 = touched.otherDebt) === null || _touched$otherDebt2 === void 0 ? void 0 : _touched$otherDebt2.debtInterestRate) && ((_touched$otherDebt3 = touched.otherDebt) === null || _touched$otherDebt3 === void 0 ? void 0 : _touched$otherDebt3.debtCurrentRepayment);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [formDebts.map(function (debt, _index) {
      return /*#__PURE__*/jsxs(StyledDebtTable, {
        children: [/*#__PURE__*/jsx("span", {
          children: debt.debtType
        }, "".concat(debt.debtType, "-").concat(_index)), /*#__PURE__*/jsxs("span", {
          children: ["$", debt.debtAmount]
        }, "".concat(debt.debtAmount, "-").concat(_index)), /*#__PURE__*/jsxs("span", {
          children: [debt.debtInterestRate, "%"]
        }, "".concat(debt.debtInterestRate, "-").concat(_index)), /*#__PURE__*/jsxs("span", {
          children: [debt.debtCurrentRepayment, "/month"]
        }, "".concat(debt.debtCurrentRepayment, "-").concat(_index)), /*#__PURE__*/jsxs("span", {
          children: [debt.debtTerm, " years"]
        }, "".concat(debt.debtTerm, "-").concat(_index)), /*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx(Button, {
          variant: "primary",
          size: "sm",
          ariaLabel: "edit",
          onClick: function onClick() {
            return onEdit(_index);
          },
          children: "Edit"
        }), /*#__PURE__*/jsx(Button, {
          variant: "empty",
          size: "sm",
          ariaLabel: "delete",
          onClick: function onClick() {
            return onDelete(_index);
          },
          children: "Delete"
        })]
      }, "debtTable-".concat(_index));
    }), /*#__PURE__*/jsx(Grid$1, {
      children: shouldShowForm ? /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("label", {
          htmlFor: generateId('myDebtIsFrom'),
          children: /*#__PURE__*/jsx(StyledHeading$1, {
            size: "xxs",
            children: "My debt is from"
          })
        }), /*#__PURE__*/jsx("form", {
          children: /*#__PURE__*/jsxs(Grid$1, {
            children: [/*#__PURE__*/jsxs(StyledRadioGroup, {
              onChange: function onChange(e) {
                setDebtType(e.target.value);
              },
              selectedValue: debtType,
              direction: "row",
              isBoxed: true,
              children: [/*#__PURE__*/jsx(StyledRadioGroup.Radio, {
                label: "Credit card",
                value: "credit card",
                id: generateId('creditCard')
              }), /*#__PURE__*/jsx(StyledRadioGroup.Radio, {
                label: "Car loan",
                value: "car loan",
                id: generateId('carLoan')
              }), /*#__PURE__*/jsx(StyledRadioGroup.Radio, {
                label: "Personal loan",
                value: "personal loan",
                id: generateId('personalLoan')
              }), /*#__PURE__*/jsx(StyledRadioGroup.Radio, {
                label: "Other loan",
                value: "other loan",
                id: generateId('otherLoan')
              })]
            }), /*#__PURE__*/jsxs(StyledUnit, {
              size: {
                lg: 3 / 7,
                sm: 1 / 2,
                xs: 1
              },
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: generateId('debtAmount'),
                children: /*#__PURE__*/jsx(StyledHeading$1, {
                  size: "xxs",
                  children: "Amount owing"
                })
              }), /*#__PURE__*/jsx(Input, {
                ref: register,
                isFullWidth: true,
                id: generateId("otherDebt.debtAmount"),
                name: "otherDebt.debtAmount",
                defaultValue: getValues("otherDebt.debtAmount"),
                size: "md",
                type: "text",
                onChange: function onChange() {
                  return undefined;
                },
                "aria-label": "amount owing",
                onBlur: debtAmountHandler.blur,
                onFocus: debtAmountHandler.focus,
                before: /*#__PURE__*/jsx(InputBefore, {
                  children: "$"
                })
              }), ((_errors$otherDebt = errors.otherDebt) === null || _errors$otherDebt === void 0 ? void 0 : _errors$otherDebt.debtAmount) && /*#__PURE__*/jsxs(Body, {
                color: "error.500",
                size: "xs",
                role: "error-alert",
                children: [/*#__PURE__*/jsx(Error$1, {
                  color: "error.500"
                }), " ", errors.otherDebt.debtAmount.message]
              })]
            }), /*#__PURE__*/jsxs(StyledUnit, {
              size: {
                lg: 1 / 7,
                sm: 1 / 2,
                xs: 1
              },
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: generateId('interestRate'),
                children: /*#__PURE__*/jsx(StyledHeading$1, {
                  size: "xxs",
                  children: "Interest rate"
                })
              }), /*#__PURE__*/jsx(Input, {
                name: "otherDebt.debtInterestRate",
                id: generateId("otherDebt.debtInterestRate"),
                defaultValue: getValues("otherDebt.debtInterestRate"),
                ref: register,
                isFullWidth: true,
                size: "md",
                onChange: function onChange() {
                  return undefined;
                },
                "aria-label": "interest rate",
                onBlur: debtInterestRateHandler.blur,
                onFocus: debtInterestRateHandler.focus,
                type: "text",
                after: /*#__PURE__*/jsx(InputAfter, {
                  children: "%"
                })
              }), ((_errors$otherDebt2 = errors.otherDebt) === null || _errors$otherDebt2 === void 0 ? void 0 : _errors$otherDebt2.debtInterestRate) && /*#__PURE__*/jsxs(Body, {
                color: "error.500",
                size: "xs",
                role: "error-alert",
                children: [/*#__PURE__*/jsx(Error$1, {
                  color: "error.500"
                }), " ", errors.otherDebt.debtInterestRate.message]
              })]
            }), /*#__PURE__*/jsxs(StyledUnit, {
              size: {
                lg: 2 / 7,
                sm: 1 / 2,
                xs: 1
              },
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: generateId('debtCurrentRepayment'),
                children: /*#__PURE__*/jsx(StyledHeading$1, {
                  size: "xxs",
                  children: "Current Repayment"
                })
              }), /*#__PURE__*/jsx(Input, {
                name: "otherDebt.debtCurrentRepayment",
                ref: register,
                isFullWidth: true,
                id: generateId("otherDebt.debtCurrentRepayment"),
                defaultValue: getValues("otherDebt.debtCurrentRepayment"),
                size: "md",
                type: "text",
                onChange: function onChange() {
                  return undefined;
                },
                "aria-label": "current repayment",
                onBlur: debtCurrentRepaymentHandler.blur,
                onFocus: debtCurrentRepaymentHandler.focus,
                before: /*#__PURE__*/jsx(InputBefore, {
                  children: "$"
                }),
                after: /*#__PURE__*/jsx(InputAfter, {
                  children: "/month"
                })
              }), ((_errors$otherDebt3 = errors.otherDebt) === null || _errors$otherDebt3 === void 0 ? void 0 : _errors$otherDebt3.debtCurrentRepayment) && /*#__PURE__*/jsxs(Body, {
                color: "error.500",
                size: "xs",
                role: "error-alert",
                children: [/*#__PURE__*/jsx(Error$1, {
                  color: "error.500"
                }), " ", errors.otherDebt.debtCurrentRepayment.message]
              })]
            }), /*#__PURE__*/jsxs(StyledUnit, {
              size: {
                lg: 1 / 7,
                sm: 1 / 2,
                xs: 1
              },
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: generateId('debtTerm'),
                children: /*#__PURE__*/jsx(StyledHeading$1, {
                  size: "xxs",
                  children: "Remaining term"
                })
              }), /*#__PURE__*/jsx(Input, {
                name: "otherDebt.debtTerm",
                id: generateId("otherDebt.debtTerm"),
                defaultValue: getValues("otherDebt.debtTerm"),
                ref: register,
                isFullWidth: true,
                size: "md",
                disabled: true,
                onChange: function onChange() {
                  return undefined;
                },
                "aria-label": "remaining term",
                onBlur: debtTermHandler.blur,
                onFocus: debtTermHandler.focus,
                type: "text",
                value: isNaN(debtRemainingTerm) || debtRemainingTerm < 1 ? '0' : Math.round(debtRemainingTerm).toLocaleString(),
                after: /*#__PURE__*/jsx(InputAfter, {
                  children: "years"
                })
              }), showDebtRemainingTermError && isNaN(debtRemainingTerm) && /*#__PURE__*/jsxs(Body, {
                color: "error.500",
                size: "xs",
                role: "error-alert",
                children: [/*#__PURE__*/jsx(Error$1, {
                  color: "error.500"
                }), " Your monthly repayment amount might be too low. Please try again."]
              })]
            }), /*#__PURE__*/jsx(Unit, {
              children: /*#__PURE__*/jsxs(Grid$1, {
                halign: "center",
                gutter: 'md',
                children: [/*#__PURE__*/jsx(StyledUnit, {
                  size: {
                    lg: 1 / 6,
                    sm: 1 / 2,
                    xs: 1
                  },
                  children: /*#__PURE__*/jsx(Button, {
                    "data-testid": "save",
                    variant: "primary",
                    size: "md",
                    isDisabled: !(!((_errors$otherDebt4 = errors.otherDebt) !== null && _errors$otherDebt4 !== void 0 && _errors$otherDebt4.debtAmount) && !((_errors$otherDebt5 = errors.otherDebt) !== null && _errors$otherDebt5 !== void 0 && _errors$otherDebt5.debtInterestRate) && !((_errors$otherDebt6 = errors.otherDebt) !== null && _errors$otherDebt6 !== void 0 && _errors$otherDebt6.debtCurrentRepayment) && isDirty),
                    onClick: function onClick() {
                      return saveDebt(debtType, _objectSpread({}, getValues().otherDebt));
                    },
                    children: "Save"
                  })
                }), /*#__PURE__*/jsx(StyledUnit, {
                  size: {
                    lg: 1 / 6,
                    sm: 1 / 2,
                    xs: 1
                  },
                  children: /*#__PURE__*/jsx(Button, {
                    "data-testid": "cancel",
                    variant: "primary",
                    isInverse: true,
                    size: "md",
                    onClick: onCancel,
                    children: "Cancel"
                  })
                })]
              })
            })]
          })
        })]
      }) : /*#__PURE__*/jsx(Unit, {
        children: /*#__PURE__*/jsx(Button, {
          "data-testid": "add",
          variant: "empty",
          size: "md",
          onClick: onAdd,
          children: "+ Add"
        })
      })
    })]
  });
};

var schema = yup.object().shape({
  homeLoanOutstandingAmount: yup.mixed().transform(function (string) {
    return numeral(string).value();
  }).test({
    name: 'min',
    message: 'Outstanding home loan amount must be greater than $0',
    test: function test(homeLoanOutstandingAmount) {
      return homeLoanOutstandingAmount > 0;
    }
  }).test({
    name: 'max',
    message: 'Outstanding home loan amount must be equal to or less than $80 million',
    test: function test(homeLoanOutstandingAmount) {
      return homeLoanOutstandingAmount <= HOMELOAN_MAXIMUM_VALUES.homeLoanOutstandingAmount;
    }
  }),
  homeLoanInterestRate: yup.number().typeError('Interest rate must be greater than 0%').min(0.01, 'Interest rate must be greater than 0%').max(HOMELOAN_MAXIMUM_VALUES.homeLoanInterestRate, 'Interest rate must be equal to or less than 20%').required('Interest rate must be greater than 0%'),
  homeLoanMonthlyRepayment: yup.mixed().transform(function (string) {
    return numeral(string).value();
  }).test({
    name: 'min',
    message: 'Repayment amount must be greater than 0',
    test: function test(homeLoanMonthlyRepayment) {
      return homeLoanMonthlyRepayment > 0;
    }
  }).test({
    name: 'max',
    message: 'Repayment amount must be less than 1,000,000',
    // message to be updated
    test: function test(homeLoanMonthlyRepayment) {
      return homeLoanMonthlyRepayment <= HOMELOAN_MAXIMUM_VALUES.homeLoanMonthlyRepayment;
    }
  }),
  newInterestRate: yup.number().typeError('Interest rate must be greater than 0%').min(0.01, 'Interest rate must be greater than 0%').max(REFI_MAXIMUM_VALUES.newInterestRate, 'Interest rate must be equal to or less than 20%').required('Interest rate must be greater than 0%'),
  newLoanTerm: yup.number().typeError('Loan term must be greater than 0 years').min(1, 'Loan term must be greater than 0 years').max(REFI_MAXIMUM_VALUES.newLoanTerm, 'Loan term must be equal to or less than 30 years').integer('Please enter a whole number').required('Loan term must be between 0 and 30 years'),
  otherDebt: yup.object({
    debtAmount: yup.mixed().transform(function (string) {
      return numeral(string).value();
    }).test({
      name: 'min',
      message: 'Amount owing must be greater than 0',
      test: function test(debtAmount) {
        return debtAmount > 0;
      }
    }).test({
      name: 'max',
      message: 'Amount owing must be equal to or less than $80 million',
      // message to be updated
      test: function test(debtAmount) {
        return debtAmount <= DEBTS_MAXIMUM_VALUES.debtAmount;
      }
    }),
    debtInterestRate: yup.number().typeError('Interest rate must be greater than 0%').min(0.01, 'Interest rate must be greater than 0%').max(DEBTS_MAXIMUM_VALUES.debtInterestRate, 'Interest rate must be equal to or less than 20%').required('Interest rate must be greater than 0%'),
    debtCurrentRepayment: yup.mixed().transform(function (string) {
      return numeral(string).value();
    }).test({
      name: 'min',
      message: 'Current repayment amount must be greater than 0',
      test: function test(debtCurrentRepayment) {
        return debtCurrentRepayment > 0;
      }
    }).test({
      name: 'max',
      message: 'Current repayment amount must be less than 1,000,000',
      test: function test(debtCurrentRepayment) {
        return debtCurrentRepayment <= DEBTS_MAXIMUM_VALUES.debtCurrentRepayment;
      }
    })
  })
});

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;
var DebtSummaryWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), my('sm'));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var StyledHeading = styled(Heading)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  strong {\n    margin-right: 4px;\n    ", "\n  }\n\n  small {\n    font-size: 14px;\n    display: inline-block;\n\n    ", ";\n  }\n"])), mt('xxs'), function (_ref) {
  var isHighlight = _ref.isHighlight;
  return isHighlight ? css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            color: ", ";\n          "])), getColour$1('text', 'contrast')) : null;
}, gte('sm')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      font-size: 18px;\n    "]))));
var Wrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background-color: #003046;\n  width: 100%;\n  box-sizing: border-box;\n  ", "\n  z-index: 1;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  border: none;\n  ", "\n  ", "\n  ", "\n  ", " {\n    height: 100%;\n  }\n\n  a {\n    align-self: flex-end;\n  }\n\n  ", " {\n    ", "\n  }\n\n  ", " {\n    font-weight: 700;\n  }\n"])), fg('shade.0'), mt('lg'), px({
  lg: 'lg',
  xs: 'md'
}), py({
  lg: 'xxl',
  xs: 'lg'
}), Grid, Body, mt('xxxs'), Heading);
var StyledGrid = styled(Grid)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var SeperatorContainer = styled(Grid.Unit)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), gte('md')(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    padding: 0;\n  "]))));
var Seperator = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n  box-sizing: border-box;\n  height: 1px;\n  margin: 28px auto;\n  padding: 0;\n  width: 100%;\n\n  ", "\n\n  ", "\n"])), bg('shade.0'), gte('md')(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    margin: 0;\n    margin-left: -1px;\n    height: unset;\n    width: 1px;\n    min-height: 100%;\n  "]))), between('xs', 'md')(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    visibility: hidden;\n    margin: 24px auto;\n  "]))));
var FlexUnit = styled(Grid.Unit)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n\n  ", " {\n    flex-basis: 100%;\n  }\n"])), Heading);
var Segment = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  width: 100%;\n\n  ", "\n\n  ", "\n\n  &:last-child {\n    ", "\n    display: flex;\n  }\n"])), gte('md')(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      width: unset;\n  "]))), gte('lg')(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    width: 100%;\n  "]))), mt({
  xs: 'sm',
  md: 'nil'
}));
var NextSteps = styled(FlexUnit)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  flex-direction: column;\n\n  ", "\n\n  ", "\n"])), between('xs', 'md')(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    justify-content: space-between;\n  "]))), gte('md')(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    row-gap: 20px;\n    justify-content: flex-start;\n  "]))));
var StyledResultWrapper = styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  ", "\n"])), mt('sm'));

var ResultsPanel = function ResultsPanel(_ref) {
  var buttonLink = _ref.buttonLink,
    buttonText = _ref.buttonText,
    results = _ref.results,
    resultPanelSubtitle = _ref.resultPanelSubtitle,
    resultPanelHeading = _ref.resultPanelHeading;
  return /*#__PURE__*/jsx(Wrapper, {
    "data-testid": "results-panel-wrapper",
    children: /*#__PURE__*/jsxs(StyledGrid, {
      gutter: "xxxl",
      children: [/*#__PURE__*/jsx(Grid.Unit, {
        size: {
          sm: 1,
          md: 2 / 3
        },
        children: /*#__PURE__*/jsx(Grid, {
          children: /*#__PURE__*/jsxs(FlexUnit, {
            size: 1,
            children: [/*#__PURE__*/jsx(Heading, {
              size: "sm",
              children: "What could you save? "
            }), /*#__PURE__*/jsxs(Grid, {
              gutter: "sm",
              children: [/*#__PURE__*/jsx(Grid.Unit, {
                size: {
                  sm: 1,
                  md: 1 / 2
                },
                children: /*#__PURE__*/jsxs(StyledResultWrapper, {
                  children: [/*#__PURE__*/jsx("label", {
                    children: /*#__PURE__*/jsx(StyledHeading, {
                      size: "xs",
                      children: "You could save"
                    })
                  }), /*#__PURE__*/jsxs(StyledHeading, {
                    size: 'lg',
                    children: [/*#__PURE__*/jsxs("strong", {
                      "data-testid": "extra-cashflow-per-month",
                      children: ["$", results ? Math.round(results.extraCashflowPerMonth).toLocaleString() : 0]
                    }), /*#__PURE__*/jsx("small", {
                      children: "/ month"
                    })]
                  })]
                })
              }), /*#__PURE__*/jsx(Grid.Unit, {
                size: {
                  sm: 1,
                  md: 1 / 2
                },
                children: /*#__PURE__*/jsxs(StyledResultWrapper, {
                  children: [/*#__PURE__*/jsx("label", {
                    children: /*#__PURE__*/jsx(StyledHeading, {
                      size: "xs",
                      children: "Potential interest saved"
                    })
                  }), /*#__PURE__*/jsx(StyledHeading, {
                    size: "lg",
                    children: /*#__PURE__*/jsxs("strong", {
                      "data-testid": "interest-saved",
                      children: ["$", results ? Math.round(results.amountSavedOnInterest).toLocaleString() : 0]
                    })
                  })]
                })
              }), /*#__PURE__*/jsx(Grid.Unit, {
                size: {
                  sm: 1,
                  md: 1 / 4
                },
                children: /*#__PURE__*/jsxs(StyledResultWrapper, {
                  children: [/*#__PURE__*/jsx("label", {
                    children: /*#__PURE__*/jsx(Body, {
                      size: "xs",
                      children: "Existing debt repayment"
                    })
                  }), /*#__PURE__*/jsxs(StyledHeading, {
                    size: "sm",
                    children: [/*#__PURE__*/jsxs("strong", {
                      "data-testid": "current-monthly-repayment",
                      children: ["$", results ? Math.round(results.currentTotalMonthlyRepayment).toLocaleString() : 0]
                    }), /*#__PURE__*/jsx("small", {
                      children: "/ month"
                    })]
                  })]
                })
              }), /*#__PURE__*/jsx(Grid.Unit, {
                size: {
                  sm: 1,
                  md: 1 / 4
                },
                children: /*#__PURE__*/jsxs(StyledResultWrapper, {
                  children: [/*#__PURE__*/jsx("label", {
                    children: /*#__PURE__*/jsx(Body, {
                      size: "xs",
                      children: "New debt repayment"
                    })
                  }), /*#__PURE__*/jsxs(StyledHeading, {
                    size: "sm",
                    children: [/*#__PURE__*/jsxs("strong", {
                      "data-testid": "new-monthly-repayment",
                      children: ["$", results ? Math.round(results.newMonthlyRepayment).toLocaleString() : 0]
                    }), /*#__PURE__*/jsx("small", {
                      children: "/ month"
                    })]
                  })]
                })
              }), /*#__PURE__*/jsx(Grid.Unit, {
                size: {
                  sm: 1,
                  md: 1 / 4
                },
                children: /*#__PURE__*/jsxs(StyledResultWrapper, {
                  children: [/*#__PURE__*/jsx("label", {
                    children: /*#__PURE__*/jsx(Body, {
                      size: "xs",
                      children: "Existing interest payable"
                    })
                  }), /*#__PURE__*/jsx(StyledHeading, {
                    size: "sm",
                    children: /*#__PURE__*/jsxs("strong", {
                      "data-testid": "existing-interest",
                      children: ["$", results ? Math.round(results.existingInterestPayable).toLocaleString() : 0]
                    })
                  }), /*#__PURE__*/jsx("small", {
                    children: "over the lifetime of your loan"
                  })]
                })
              }), /*#__PURE__*/jsx(Grid.Unit, {
                size: {
                  sm: 1,
                  md: 1 / 4
                },
                children: /*#__PURE__*/jsxs(StyledResultWrapper, {
                  children: [/*#__PURE__*/jsx("label", {
                    children: /*#__PURE__*/jsx(Body, {
                      size: "xs",
                      children: "New interest payable"
                    })
                  }), /*#__PURE__*/jsx(StyledHeading, {
                    size: "sm",
                    children: /*#__PURE__*/jsxs("strong", {
                      "data-testid": "new-interest",
                      children: ["$", results ? Math.round(results.newInterestPayable).toLocaleString() : 0]
                    })
                  }), /*#__PURE__*/jsx("small", {
                    children: "after refinancing"
                  })]
                })
              })]
            })]
          })
        })
      }), /*#__PURE__*/jsx(SeperatorContainer, {
        size: {
          md: 0,
          sm: 1
        },
        children: /*#__PURE__*/jsx(Seperator, {})
      }), /*#__PURE__*/jsx(Grid.Unit, {
        size: {
          md: 1 / 3,
          sm: 1
        },
        children: /*#__PURE__*/jsx(Grid, {
          children: /*#__PURE__*/jsxs(NextSteps, {
            size: {
              sm: 1
            },
            children: [/*#__PURE__*/jsxs(Segment, {
              children: [/*#__PURE__*/jsx(Heading, {
                size: "sm",
                children: resultPanelHeading
              }), /*#__PURE__*/jsx(Body, {
                size: "sm",
                children: resultPanelSubtitle
              })]
            }), /*#__PURE__*/jsx(Segment, {
              children: buttonText && buttonLink && /*#__PURE__*/jsx(Button, {
                isFullWidth: true,
                type: "submit",
                variant: "primary",
                size: "md",
                href: embedMarketingTrackingIntoURL(buttonLink),
                children: buttonText
              })
            })]
          })
        })
      })]
    })
  });
};

var DebtConsolidationCalculator = function DebtConsolidationCalculator(_ref) {
  var buttonText = _ref.buttonText,
    buttonLink = _ref.buttonLink,
    disclaimer = _ref.disclaimer,
    resultBody = _ref.resultBody,
    resultHeading = _ref.resultHeading;
  // Calculation states
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    results = _useState2[0],
    setResults = _useState2[1];
  var generateId = useGenerateId();

  // Main Calculator Form Hook
  var methods = useForm({
    resolver: yupResolver(schema),
    reValidateMode: 'onChange',
    mode: 'onChange',
    defaultValues: _objectSpread(_objectSpread(_objectSpread({}, HOMELOAN_DEFAULT_VALUES), DEBTS_DEFAULT_VALUES), REFI_DEFAULT_VALUES),
    shouldUnregister: false
  });
  var errors = methods.errors,
    handleSubmit = methods.handleSubmit,
    register = methods.register,
    trigger = methods.trigger,
    getValues = methods.getValues,
    watch = methods.watch,
    _methods$formState = methods.formState,
    isValid = _methods$formState.isValid,
    isDirty = _methods$formState.isDirty,
    isSubmitted = _methods$formState.isSubmitted,
    touched = _methods$formState.touched;
  var homeLoanOutstandingAmountHandler = createInputHandler(HOMELOAN_MAXIMUM_VALUES.homeLoanOutstandingAmount, function () {
    return trigger('homeLoanOutstandingAmount');
  });
  var homeLoanInterestRateHandler = createInputHandler(HOMELOAN_MAXIMUM_VALUES.homeLoanInterestRate, function () {
    return trigger('homeLoanInterestRate');
  }, '0.00');
  var homeLoanMonthlyRepaymentHandler = createInputHandler(HOMELOAN_MAXIMUM_VALUES.homeLoanMonthlyRepayment, function () {
    return trigger('homeLoanMonthlyRepayment');
  }, '0');
  var homeLoanRemainingTermHandler = createInputHandler(HOMELOAN_MAXIMUM_VALUES.homeLoanRemainingTerm, function () {
    return trigger('homeLoanRemainingTerm');
  });
  var currentTotalDebtHandler = createInputHandler(REFI_MAXIMUM_VALUES.currentTotalDebt, function () {
    return trigger('currentTotalDebt');
  }, '0');
  var newInterestRateHandler = createInputHandler(REFI_MAXIMUM_VALUES.newInterestRate, function () {
    return trigger('newInterestRate');
  }, '0.00');
  var newloanTermHandler = createInputHandler(REFI_MAXIMUM_VALUES.newLoanTerm, function () {
    return trigger('newLoanTerm');
  });
  var onSubmit = function onSubmit() {
    // calculations for results panel
    var newMonthlyRepayment = calculateNewMonthlyRepayment(getValues(), currentTotalDebt);
    var extraCashflowPerMonth = Math.round(calculateExtraCashflow(currentTotalMonthlyRepayment, newMonthlyRepayment));
    var existingInterestPayable = calculateExistingInterestPayable(getValues(), homeLoanRemainingTerm);
    var newInterestPayable = calculateNewInterestPayable(getValues(), newMonthlyRepayment, currentTotalDebt);
    var amountSavedOnInterest = Math.round(calculateAmountSavedOnInterest(existingInterestPayable, newInterestPayable));
    setResults({
      extraCashflowPerMonth: extraCashflowPerMonth,
      amountSavedOnInterest: amountSavedOnInterest,
      currentTotalMonthlyRepayment: currentTotalMonthlyRepayment,
      newMonthlyRepayment: newMonthlyRepayment,
      existingInterestPayable: existingInterestPayable,
      newInterestPayable: newInterestPayable
    });
  };
  var values = watch();
  var homeLoanRemainingTerm = calculateHomeLoanRemainingTerm(values);
  var currentTotalDebt = Math.round(sumOfDebtAmounts(values));
  var currentTotalMonthlyRepayment = Math.round(sumOfMonthlyRepayments(values, homeLoanRemainingTerm));
  var showHomeLoanRemainingTermError = touched.homeLoanOutstandingAmount && touched.homeLoanInterestRate && touched.homeLoanMonthlyRepayment;
  return /*#__PURE__*/jsx(FormProvider, _objectSpread(_objectSpread({}, methods), {}, {
    children: /*#__PURE__*/jsxs(Wrapper$1, {
      children: [/*#__PURE__*/jsxs(Calculator, {
        onSubmit: handleSubmit(onSubmit),
        children: [/*#__PURE__*/jsx(Title, {
          size: 'sm',
          children: "1. Your existing home loan"
        }), /*#__PURE__*/jsxs(Grid, {
          children: [/*#__PURE__*/jsxs(StyledUnit, {
            size: {
              lg: 3 / 7,
              sm: 1 / 2,
              xs: 1
            },
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: generateId('homeLoanOutstandingAmount'),
              children: /*#__PURE__*/jsx(StyledHeading, {
                size: "xxs",
                children: "Outstanding home loan amount"
              })
            }), /*#__PURE__*/jsx(Input, {
              ref: register,
              isFullWidth: true,
              id: generateId('homeLoanOutstandingAmount'),
              name: "homeLoanOutstandingAmount",
              size: "md",
              type: "text",
              onChange: function onChange() {
                return undefined;
              },
              "aria-label": "outstanding-home-loan-amount",
              onBlur: homeLoanOutstandingAmountHandler.blur,
              onFocus: homeLoanOutstandingAmountHandler.focus,
              before: /*#__PURE__*/jsx(InputBefore, {
                children: "$"
              })
            }), errors.homeLoanOutstandingAmount && /*#__PURE__*/jsxs(Body, {
              color: "error.500",
              size: "xs",
              role: "error-alert",
              children: [/*#__PURE__*/jsx(Error$1, {
                color: "error.500"
              }), " ", errors.homeLoanOutstandingAmount.message]
            })]
          }), /*#__PURE__*/jsxs(StyledUnit, {
            size: {
              lg: 1 / 7,
              sm: 1 / 2,
              xs: 1
            },
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: generateId('homeLoanInterestRate'),
              children: /*#__PURE__*/jsx(StyledHeading, {
                size: "xxs",
                children: "Interest rate"
              })
            }), /*#__PURE__*/jsx(Input, {
              name: "homeLoanInterestRate",
              id: generateId('homeLoanInterestRate'),
              ref: register,
              isFullWidth: true,
              size: "md",
              onChange: function onChange() {
                return undefined;
              },
              "aria-label": "home loan interest rate",
              onBlur: homeLoanInterestRateHandler.blur,
              onFocus: homeLoanInterestRateHandler.focus,
              type: "text",
              after: /*#__PURE__*/jsx(InputAfter, {
                children: "%"
              })
            }), errors.homeLoanInterestRate && /*#__PURE__*/jsxs(Body, {
              color: "error.500",
              size: "xs",
              role: "error-alert",
              children: [/*#__PURE__*/jsx(Error$1, {
                color: "error.500"
              }), " ", errors.homeLoanInterestRate.message]
            })]
          }), /*#__PURE__*/jsxs(StyledUnit, {
            size: {
              lg: 2 / 7,
              sm: 1 / 2,
              xs: 1
            },
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: generateId('homeLoanMonthlyRepayment'),
              children: /*#__PURE__*/jsx(StyledHeading, {
                size: "xxs",
                children: "Current Repayment"
              })
            }), /*#__PURE__*/jsx(Input, {
              ref: register,
              isFullWidth: true,
              id: generateId('homeLoanMonthlyRepayment'),
              name: "homeLoanMonthlyRepayment",
              size: "md",
              type: "text",
              onChange: function onChange() {
                return undefined;
              },
              "aria-label": "home loan monthly repayment",
              onBlur: homeLoanMonthlyRepaymentHandler.blur,
              onFocus: homeLoanMonthlyRepaymentHandler.focus,
              before: /*#__PURE__*/jsx(InputBefore, {
                children: "$"
              }),
              after: /*#__PURE__*/jsx(InputAfter, {
                children: "/month"
              })
            }), errors.homeLoanMonthlyRepayment && /*#__PURE__*/jsxs(Body, {
              color: "error.500",
              size: "xs",
              role: "error-alert",
              children: [/*#__PURE__*/jsx(Error$1, {
                color: "error.500"
              }), " ", errors.homeLoanMonthlyRepayment.message]
            })]
          }), /*#__PURE__*/jsxs(StyledUnit, {
            size: {
              lg: 1 / 7,
              sm: 1 / 2,
              xs: 1
            },
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: generateId('homeLoanRemainingTerm'),
              children: /*#__PURE__*/jsx(StyledHeading, {
                size: "xxs",
                children: "Remaining term"
              })
            }), /*#__PURE__*/jsx(Input, {
              name: "homeLoanRemainingTerm",
              id: generateId('homeLoanRemainingTerm'),
              ref: register,
              isFullWidth: true,
              size: "md",
              disabled: true,
              onChange: function onChange() {
                return undefined;
              },
              "aria-label": "home loan remaining term",
              onBlur: homeLoanRemainingTermHandler.blur,
              onFocus: homeLoanRemainingTermHandler.focus,
              type: "text",
              value: isNaN(homeLoanRemainingTerm) || homeLoanRemainingTerm < 1 || homeLoanRemainingTerm > 30 ? '0' : Math.round(homeLoanRemainingTerm).toLocaleString(),
              after: /*#__PURE__*/jsx(InputAfter, {
                children: "years"
              })
            }), showHomeLoanRemainingTermError && (isNaN(homeLoanRemainingTerm) || homeLoanRemainingTerm > 30) && /*#__PURE__*/jsxs(Body, {
              color: "error.500",
              size: "xs",
              role: "error-alert",
              children: [/*#__PURE__*/jsx(Error$1, {
                color: "error.500"
              }), " Your monthly repayment amount might be too low. Please try again."]
            })]
          }), /*#__PURE__*/jsx(StyledUnit, {
            size: {
              lg: 1 / 2,
              sm: 1
            }
          })]
        }), /*#__PURE__*/jsx(Title, {
          size: 'sm',
          children: "2. Other debt to consolidate"
        }), /*#__PURE__*/jsx(OtherDebtsForm, {}), /*#__PURE__*/jsxs(DebtSummaryWrapper, {
          children: [/*#__PURE__*/jsx(Title, {
            size: 'sm',
            children: "Existing debt summary"
          }), /*#__PURE__*/jsxs(Grid, {
            children: [/*#__PURE__*/jsx(Grid.Unit, {
              size: {
                sm: 1,
                md: 1 / 2
              },
              children: /*#__PURE__*/jsx(Grid, {
                children: /*#__PURE__*/jsxs(FlexUnit, {
                  size: 1,
                  children: [/*#__PURE__*/jsx(Heading, {
                    size: "xs",
                    children: "Your total existing debt"
                  }), /*#__PURE__*/jsx(StyledHeading, {
                    size: "xl",
                    isHighlight: true,
                    children: /*#__PURE__*/jsxs("strong", {
                      "data-testid": "current-total-debt-display",
                      children: ["$", currentTotalDebt.toLocaleString()]
                    })
                  })]
                })
              })
            }), /*#__PURE__*/jsx(Grid.Unit, {
              size: {
                sm: 1,
                md: 1 / 2
              },
              children: /*#__PURE__*/jsx(Grid, {
                children: /*#__PURE__*/jsxs(FlexUnit, {
                  size: 1,
                  children: [/*#__PURE__*/jsx(Heading, {
                    size: "xs",
                    children: "Your current minimum repayment is"
                  }), /*#__PURE__*/jsxs(StyledHeading, {
                    size: "xl",
                    isHighlight: true,
                    children: [/*#__PURE__*/jsxs("strong", {
                      "data-testid": "current-total-min-repayments-display",
                      children: ["$", currentTotalMonthlyRepayment.toLocaleString()]
                    }), /*#__PURE__*/jsx("small", {
                      children: "/month"
                    })]
                  })]
                })
              })
            })]
          })]
        }), /*#__PURE__*/jsx(Title, {
          size: 'sm',
          children: "3. Refinance to a better rate"
        }), /*#__PURE__*/jsxs(Grid, {
          children: [/*#__PURE__*/jsxs(StyledUnit, {
            size: {
              lg: 3 / 7,
              sm: 1 / 2,
              xs: 1
            },
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: generateId('currentTotalDebt'),
              children: /*#__PURE__*/jsx(StyledHeading, {
                size: "xxs",
                children: "Current total loan amount"
              })
            }), /*#__PURE__*/jsx(Input, {
              ref: register,
              isFullWidth: true,
              id: generateId('currentTotalDebt'),
              disabled: true,
              name: "currentTotalDebt",
              size: "md",
              type: "text",
              onChange: function onChange() {
                return undefined;
              },
              "aria-label": "current total loan amount",
              onBlur: currentTotalDebtHandler.blur,
              onFocus: currentTotalDebtHandler.focus,
              value: currentTotalDebt.toLocaleString(),
              before: /*#__PURE__*/jsx(InputBefore, {
                children: "$"
              })
            }), errors.currentTotalDebt && /*#__PURE__*/jsxs(Body, {
              color: "error.500",
              size: "xs",
              role: "error-alert",
              children: [/*#__PURE__*/jsx(Error$1, {
                color: "error.500"
              }), errors.currentTotalDebt.message]
            })]
          }), /*#__PURE__*/jsxs(StyledUnit, {
            size: {
              lg: 1 / 7,
              sm: 1 / 2,
              xs: 1
            },
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: generateId('newInterestRate'),
              children: /*#__PURE__*/jsx(StyledHeading, {
                size: "xxs",
                children: "Interest rate"
              })
            }), /*#__PURE__*/jsx(Input, {
              name: "newInterestRate",
              id: generateId('newInterestRate'),
              ref: register,
              isFullWidth: true,
              size: "md",
              onChange: function onChange() {
                return undefined;
              },
              "aria-label": "new interest rate",
              onBlur: newInterestRateHandler.blur,
              onFocus: newInterestRateHandler.focus,
              type: "text",
              after: /*#__PURE__*/jsx(InputAfter, {
                children: "%"
              })
            }), errors.newInterestRate && /*#__PURE__*/jsxs(Body, {
              color: "error.500",
              size: "xs",
              role: "error-alert",
              children: [/*#__PURE__*/jsx(Error$1, {
                color: "error.500"
              }), " ", errors.newInterestRate.message]
            })]
          }), /*#__PURE__*/jsxs(StyledUnit, {
            size: {
              lg: 2 / 7,
              sm: 1 / 2,
              xs: 1
            },
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: generateId('newLoanTerm'),
              children: /*#__PURE__*/jsx(StyledHeading, {
                size: "xxs",
                children: "New loan term"
              })
            }), /*#__PURE__*/jsx(Input, {
              name: "newLoanTerm",
              id: generateId('newLoanTerm'),
              ref: register,
              isFullWidth: true,
              size: "md",
              onChange: function onChange() {
                return undefined;
              },
              "aria-label": "new loan term",
              onBlur: newloanTermHandler.blur,
              onFocus: newloanTermHandler.focus,
              type: "text",
              after: /*#__PURE__*/jsx(InputAfter, {
                children: "years"
              })
            }), errors.newLoanTerm && /*#__PURE__*/jsxs(Body, {
              color: "error.500",
              size: "xs",
              role: "error-alert",
              children: [/*#__PURE__*/jsx(Error$1, {
                color: "error.500"
              }), " ", errors.newLoanTerm.message]
            })]
          }), /*#__PURE__*/jsx(StyledUnit, {
            size: {
              lg: 1 / 2,
              sm: 1
            }
          })]
        }), /*#__PURE__*/jsx(StyledUnit, {
          size: 1,
          children: /*#__PURE__*/jsx(StyledButton, {
            "data-testid": "calculate-button",
            type: "submit",
            variant: "primary",
            size: "md",
            isDisabled: !(isValid && (isDirty || !isSubmitted)),
            children: "Calculate"
          })
        })]
      }), results ? /*#__PURE__*/jsx(ResultsPanel, {
        buttonLink: buttonLink,
        buttonText: buttonText,
        resultPanelSubtitle: resultBody,
        resultPanelHeading: resultHeading,
        results: results
      }) : null, disclaimer && /*#__PURE__*/jsx(ResultsWrapper, {
        children: /*#__PURE__*/jsx(Summary, {
          children: disclaimer
        })
      })]
    })
  }));
};

export { DebtConsolidationCalculator as default };
